import React from 'react';
import { facebook, facebookFooter, footerLogo, instagram, instagramFooter } from '../../assets/images';
import { useTranslation } from 'react-i18next';

const Footer = () => {

  const { t, i18n } = useTranslation();

  return (
    <footer className="bg-[#223077] mt-[40px] md:mt-[224px]">
      <div className="max-w-containerSm md:max-w-container mx-auto grid grid-cols-1 md:grid-cols-5 gap-8 py-8 text-white">
        <div>
         <img className='w-[124px]' src={footerLogo}></img>
          <p className='text-[16px] mt-[10px] text-white'>{t("TANURA ilə Hər Gün Təravətli Dəri")}</p>
        </div>
        <div className='hidden md:block'>

        </div>
        <div>
          <h4 className="text-[14px] font-medium">{t("Əsas bağlantılar")}</h4>
          <ul className='text-[14px] mt-[18px] space-y-2 md:space-y-4'>
            <li><a href="/" className="hover:underline">{t("Ana səhifə")}</a></li>
            <li><a href="/about" className="hover:underline">{t("Haqqımızda")}</a></li>
            <li><a href="/products" className="hover:underline">{t("Məhsullar")}</a></li>
            <li><a href="/contact" className="hover:underline">{t("Əlaqə")}</a></li>
          </ul>
        </div>
        <div>
          <h4 className="text-[14px] font-medium">{t("Məhsullar")}</h4>
          <ul className='text-[14px] mt-[18px] space-y-2 md:space-y-4'>
            <li><a href="/products" className="hover:underline">{t("Ev devam ürünleri")}</a></li>
            <li><a href="/products" className="hover:underline">{t("Kabin ürünler")}</a></li>
            <li><a href="/products" className="hover:underline">{t("Set məhsullar")}</a></li>
          </ul>
        </div>
        <div> 
          <h4 className="text-[14px] font-medium">{t("Bizimlə əlaqə saxlayın")}</h4>
          <ul className='text-[14px] space-y-2 md:space-y-4 mt-[14px]'>
            <li><a href="/products" className="hover:underline">+994 70 370 55 70</a></li>
          </ul>
          <h4 className="text-[14px] font-medium mt-[26px]">{t("Sosial şəbəkələr")}</h4>
          <div className='flex gap-2 mt-[14px]'> 
 <a href='/'>
 <img className='w-6 h-6' src={instagramFooter}></img></a>
 <a href='/'>
 <img className='w-6 h-6' src={facebookFooter}></img></a>
 
    </div>
        </div>
      </div>
      <div className='bg-[black] h-[1px] max-w-containerSm md:max-w-container mx-auto'></div>
      <div className="max-w-containerSm md:max-w-container md:flex justify-between mx-auto py-4 text-sm text-white">
        <p>Tanura.az © {t("Bütün hüquqlar qorunur.")}</p>
        <p>{t("Sayt hazırlandı")}: Birsayt.az</p>
      </div>
    </footer>
  );
};

export default Footer;
